import {createAction} from '@reduxjs/toolkit'

import {PaymentTabMethodType} from '@web/core/constants'

import {AccountKey, CardId, MobileNumbers} from './interfaces'

export const selectWithdrawalAccountKey = createAction<AccountKey>('priorityPaymentMethod/selectWithdrawalAccountKey')
export const selectSecondWithdrawalAccountKey = createAction<AccountKey>(
    'priorityPaymentMethod/selectSecondWithdrawalAccountKey',
)

export const selectEasyBankAccountKey = createAction<AccountKey>('priorityPaymentMethod/selectEasyBankAccountKey')
export const selectSecondEasyBankAccountKey = createAction<AccountKey>(
    'priorityPaymentMethod/selectSecondEasyBankAccountKey',
)

export const selectEasyCardId = createAction<CardId>('priorityPaymentMethod/selectEasyCardId')
export const selectSecondEasyCardId = createAction<CardId>('priorityPaymentMethod/selectSecondEasyCardId')

export const updateMobileNumbers = createAction<MobileNumbers>('priorityPaymentMethod/updateMobileNumbers')

export const startProcess = createAction('priorityPaymentMethod/startProcess')

/** 1순위 결제수단 선택 */
export const updateFirstPayMethod = createAction<PaymentTabMethodType>('priorityPaymentMethod/updateFirstPayMethod')

/** 2순위 결제수단 선택 */
export const updateSecondPayMethod = createAction<PaymentTabMethodType>('priorityPaymentMethod/updateSecondPayMethod')
